import { css } from 'styled-components';

export const Cluster = css`
  .map-hotels-cluster {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 0;
    height: 0;
    line-height: 0;
    padding: 13px;
    cursor: pointer;
    font-family: Backpack;
    font-size: 13px;
    font-weight: bold;
    background: #fff;
    border-radius: 50%;
    position: relative;
    text-align: center;
    color: #919499;

    &.inList {
      color: #1292e0;
      &::before {
        background-image: linear-gradient(to bottom, #3a4ed5 0%, #3acfd5 100%);
      }
    }
  }
  .map-hotels-cluster.cluster_large {
    padding: 17px;
  }

  .map-hotels-cluster.cluster_medium {
    padding: 15px;
  }

  .map-hotels-cluster::before {
    border-radius: 50%;
    content: '';
    background: #919499;
    padding: 2px;
    width: 100%;
    height: 100%;
    top: -2px;
    left: -2px;
    position: absolute;
    z-index: -1;
    box-sizing: content-box;
  }
`;
